import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { KeycloakService } from '../../services/keycloak.service';

@Component({
  selector: 'md-debug-token',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './debug-token.component.html',
})
export class DebugTokenComponent {
  constructor(
    public auth: AuthService,
    public keycloak: KeycloakService,
    private router: Router,
  ) {}

  get decodedToken(): Record<string, unknown> | null {
    return this.auth.decodeToken() as Record<string, unknown> | null;
  }

  get activeCompany(): string | undefined {
    return this.auth.company;
  }

  get groupsList(): string[] {
    return this.keycloak.groups ?? [];
  }

  goBack(): void {
    this.router.navigate(['/']);
  }
}
